import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState, useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalAddGroup = ({
  server,
  languaje,
  mode,
  setDataWorkFlow,
  dataWorkFlow,
  closeModal,
  SetElementList,
  elementsList,
  handleRemoveItem
}) => {


  const [disabled, setDisabled] = useState(true)


  const reqField = () => {
    return (
      <p className='reqField-gs'>
        *
      </p>
    )
  }



  const metricData = useFetch('cassia/host_groups/by_type/1', '', '', 'GET', server)
  // const metricData=useFetch('cassia/brands','','','GET',server)



  const changeOption = (option, index) => {
    let attr = ''
    if (option.filter == 'Marcas') {
      attr = 'brand_id'
    } else if (option.filter == 'hostModel') {
      attr = 'model_id'
    }
    else if (option.filter == 'period') {
      attr = 'agent_type_id'
    }
    else if (option.filter == 'trigger') {
      attr = 'value_type_id'
    }

    // setManttoData((prevState)=>{
    //     return {
    //         ...prevState,
    //         [attr]:option.value===""?0:(parseInt(option.value))
    //     }

    // })
    // setManttoRelation(option.value)
    setDataWorkFlow((prevState) => {
      return {
        ...prevState,
        ['groupid']: option.value === "" ? 0 : (parseInt(option.value))
      }

    })
    SetElementList((prevState) => {
      return {
        ...prevState,
        ['group']: option.label
      }

    })
  }

  const cancelItem = () => {
    setDataWorkFlow((prevState) => {
      return {
        ...prevState,
        ['groupid']: null
      }

    })
    SetElementList((prevState) => {
      return {
        ...prevState,
        ['group']: ""
      }

    })
    handleRemoveItem({ id: 'group', label: capitalizeFirstLetter(lang[languaje]['grupo']), type: 'entity' })
    closeModal()
  }


  const { groupid } = dataWorkFlow;
  return (
    <div className="modal-GS-content">
      <div className='card-modal-gs modal-verificate'>
        <div className='head-card-modal-gs'>
          <div className='title-head-card-modal-gs'>
            {(lang[languaje]['agregar'].toUpperCase()) + ' ' + lang[languaje]['grupo'].toUpperCase()}
          </div>
        </div>
        <div className='content-card-modal-gs' style={{ overflowY: 'scroll', scrollbarWidth: 'thin' }}>

          <div className="form-GS-box">

            <div className="user-box-GS " style={{ height: '50%' }}>
              <label className='label-GS' style={{ top: '2% ' }}>{capitalizeFirstLetter(lang[languaje]['grupos'])}{(groupid == 0) ? reqField() : ''}</label>
              {
                (metricData.loading) ? <p style={{ color: 'var(--txt-color)' }}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p> :
                  <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''} opt_de={(groupid == null) ? 0 : metricData} origen={'Admin'} data={metricData.data.data} loading={metricData.loading} titulo='Grupos' selectFunction={changeOption} index={0}></SelectorAdmin>
              }
            </div>





            <div className="user-box-GS" style={{ height: '50%' }}>
              {

                <>
                  <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])} action={cancelItem} />
                  <Action disabled={(groupid == 0 ? true : false)} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])} action={closeModal} />
                </>
                // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
              }

              {
                // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalAddGroup